export default "__VITE_ASSET__701b661e__"